<template>
  <div>
    <chart
      v-if="data.loaded && data.labels.length"
      :chart-data="chartData"
      :chart-options="chartOptions"
    />
    <b-alert
      v-else
      show
      variant="warning"
      class="w-50 mx-auto text-center"
    >
      There's no data to show
    </b-alert>
  </div>
</template>
<script>
import Chart from '@/modules/reporting/components/Chart.vue';

export default {
  name: 'ClickPerformanceChart',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  components: {
    Chart,
  },
  data() {
    return {
      chartData: {
        labels: this.data.labels,
        datasets: [
          {
            type: 'bar',
            label: 'CLICKS',
            backgroundColor: '#9DAFE6',
            hoverBackgroundColor: '#293A73',
            borderWidth: 0,
            data: this.data.clicks,
            yAxisID: 'Click-axis',
            order: 2,
          },
          {
            type: 'line',
            label: 'CTR%',
            backgroundColor: '#2A51C7',
            borderColor: '#2A51C7',
            pointBackgroundColor: '#2A51C7',
            pointBorderColor: '#2A51C7',
            fill: false,
            borderWidth: 2,
            lineTension: 0.3,
            data: this.data.ctr,
            yAxisID: 'CTR-axis',
            ticks: {
              beginAtZero: true,
            },
            order: 1,
          },
        ],
      },
      chartOptions: {
        scales: {
          yAxes: [
            {
              id: 'Click-axis',
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                color: '#666',
              },
            },
            {
              id: 'CTR-axis',
              display: false,
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                color: '#666',
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 12,
          },
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
      },
    };
  },
};
</script>
<style>
</style>
